import styles from "./Leaderboard.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import WatsonApi from "../../../backends/WatsonApi";
import classNames from "classnames";
import ClickableLink from "../../utilities/ClickableLink";
import { useStores } from "../../../stores/useStores";
import { Suspense } from "react";
import { IView } from "../../../stores/InterfaceStore";

async function LeaderboardMembersList() {
  const { organizationStore } = useStores();

  let data: Array<{ rank: number; name: string }> = [];
  try {
    const client = await WatsonApi();
    const response = await client.apis.organizations.organizations_leaderboard({
      id: organizationStore.currentOrganization.id,
    });
    data = JSON.parse(response.data);
  } catch {
    data = [];
  }

  return (
    <ol>
      {data.map((d, idx) => {
        const itemClassName = classNames({
          [styles.item]: true,
          [styles.itemIsMe]: d["me"],
        });
        return (
          <li key={idx} className={itemClassName}>
            {d.rank} - {d.name}
          </li>
        );
      })}
    </ol>
  );
}

export default function Leaderboard() {
  const { interfaceStore } = useStores();

  return (
    <div className={styles.container}>
      <div>
        <h3>DISCUSSION LEADERBOARD</h3>
        {interfaceStore.view !== IView.LEADERBOARD && (
          <ClickableLink href={"/leaderboard"}>
            Learn More{" "}
            <FontAwesome prefix={"far"} name={"fa-question-circle"} />
          </ClickableLink>
        )}
      </div>
      <Suspense>
        <LeaderboardMembersList />
      </Suspense>
    </div>
  );
}
